import React, { useEffect, useState } from 'react'

import Select from 'react-select'
// import { QueryGetBairros } from '../../../../graphql/services/Bairros'
import { FormLabel } from 'react-bootstrap'
import { useBairros } from './useBairros'

export function GetBairrosChosen({
  setValue,
  value,
  idCidade
}:{setValue:any, value:any, idCidade:number}) {
  let BairrosArray = []

  const [bairro, setBairro] = useState(null)
  const {bairros,fetchBairros} =  useBairros()

  useEffect(() => {
    setBairro(value)
  }, [value])

  useEffect(()=>{
    if (idCidade){
      fetchBairros(idCidade)
    }
  },[idCidade])
  

  if (!bairros) {
    return (
      <>
        <div className='form-group'>
        <FormLabel className='form-label'>Bairros</FormLabel>
          {/* <label className='col-form-label'>Bairros Disponiveis:</label> */}
          <Select
            options={BairrosArray}
            onChange={(e) => {
              setBairro(e.value)
            }}
            value={BairrosArray.filter((e) => e.value)[0]}
            name='id_Bairro'
            placeholder='Bairros Disponiveis'
          />
        </div>
      </>
    )
  }
  BairrosArray.push({ value:'', label: '--selecione--' })
  bairros.map((options) => {
    BairrosArray.push({ value: options.id, label: options.bairro })
    return []
  })

  
console.log(bairro)
console.log(BairrosArray)



function containsAny(arr1: any[], arr2: string | any[]) {
  return arr1.filter((item: { value: any; }) => {
    return arr2.includes(item.value)
  })
}
console.log( bairro ? bairro : BairrosArray.find((e) => e.value === bairro) || null)

  return (
    <>
      <div className='form-group'>
      <FormLabel className='form-label'>Bairros</FormLabel>
        {/* <label className='col-form-label'>Bairros Disponiveis:</label> */}
        <Select  isMulti={true}
          value={  bairro ? bairro : BairrosArray.find((e) => e.value === bairro) || null}
          options={BairrosArray}
          onChange={(itens) => {
            console.log(itens)
            setBairro(itens)
            setValue(itens.map(opt=>opt.value))
            // SetValueBairro(e.value)
          }}
          name='id_Bairro'
          placeholder='Bairros'
        />
      </div>
    </>
  )
}
